import { render, staticRenderFns } from "./ListReturnBill.vue?vue&type=template&id=5871afae&"
import script from "./ListReturnBill.vue?vue&type=script&lang=js&"
export * from "./ListReturnBill.vue?vue&type=script&lang=js&"
import style0 from "./ListReturnBill.vue?vue&type=style&index=0&id=5871afae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports